// Next.js does not prepend basePath to raw fetch() calls.
// Use this helper for all client-side API fetches.
const BASE = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export const apiUrl = (path: string) => `${BASE}${path}`;
